import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'atlas-title',
  templateUrl: './title.component.html',
  styleUrls: ['./title.component.scss', '../common.scss'],
})
export class TitleComponent {
  isInteractable: boolean;
  @Input() icon: string;
  @Input() set interactable(val: string) {
    this.isInteractable = val !== 'false';
  }

  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() click = new EventEmitter();
}
